var exports = {
  "HB": "FeedReplies.module__thread___QkRHMT",
  "uX": "FeedReplies.module__textButton___QkRHMT",
  "MI": "FeedReplies.module__liked___QkRHMT",
  "j": "FeedReplies.module__likeIcon___QkRHMT",
  "Iq": "FeedReplies.module__authorTag___QkRHMT",
};

module.exports = exports;
